import React from 'react';
import {
	styled,
	ParentBoundComponent,
	Module
} from 'ps-gui';

/*
import {
	CellMainText,
	CellSubText
} from './portalresultsetmodule';
*/

import NotificationAdminModel, { clientTypes } from './notificationadminmodel';
import { renderDateTimeCell } from './commoncellrenderers';
import { getPhrase } from '../data/phrases';
import { CellMainText, CellSubText } from './portalresultsetmodule';

const Wrapper = styled.div`
`;

export default class NotificationAdminModule extends ParentBoundComponent {

	getModel() {
		return new NotificationAdminModel(this.getData());
	}

	setModel(model) {
		this.setData(model.getData());
	}

	componentDidMount() {
		if (!this.getData().get('initialized')) {
			this.setModel(this.getModel().initialize());
		}
	}

	render() {
		const data = this.getData();
		return (
			<Wrapper>
				<Module
					appState={data.get('esad')}
					onDataChange={newData => {
						this.setData(data.setIn(['esad', 'data'], newData));
					}}
					customResultProps={customResultProps}
				/>
			</Wrapper>
		);
	}
}

const cellRendererMap = Object.freeze({
	from_date: renderDateTimeCell,
	to_date: renderDateTimeCell,
	notification_channel: (cell, row) => {
		return (
			<>
				<CellMainText>{cell}</CellMainText>
				<CellSubText>
					{
						clientTypes.map((ct, index) => {
							if (row.get(ct.snakeCase) === 'Y') {
								return getPhrase(ct.camelCase);
							}
						}).filter(Boolean).join(', ')
					}
				</CellSubText>
			</>
		);
	},
});

const customResultProps = {
	cellRendererMap,
	withNewEntityButton: true,
	withRowSelection: true,
	defaultColumnWidths: {
		'is_deleted': '120px',
		'from_date': '120px',
		'to_date': '120px',
		notification_channel: '280px',
	},
	columnFilters: {
		'is_deleted': {
			type: 'lookup',
			lookup: 'ynBoolean'
		},
		'comments': {
			type: 'text',
		},
		'notification_channel': {
			type: 'lookup',
			lookup: 'notificationChannel'
		},
		'from_date': {
			type: 'date'
		},
		'to_date': {
			type: 'date'
		},
		'created_when': {
			type: 'date'
		},
		'edited_when': {
			type: 'date'
		},
	}
};

